import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { TextField } from '@material-ui/core';
import ReactApiService from '../../services/reactApiService'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
		minWidth: '500px'
  },
}))(MuiDialogActions);

const AddButton = withStyles((theme) => ({
	root: {
		backgroundColor: '#00c8f4',
    '&:hover': {
      backgroundColor: '#90caf9',
    },		
	}
}))(Fab);

const SaveButton = withStyles((theme) => ({
	root: {
		width: '120px',
		height: '30px',
		color: '#000',
		backgroundColor: '#00c8f4',
    '&:hover': {
      backgroundColor: '#90caf9',
    },		
	}
}))(Fab);
	
export default function AddMaskDialog(props) {

  const [open, setOpen] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);

  const handleClickOpen = () => {
		setSaveButtonDisabled(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
	
	const onChange = (event) => {
		if ( event.target.value.length > 0 ) {
			setSaveButtonDisabled(false);
		} else {	
			setSaveButtonDisabled(true);
		}
	}
	
	const dataService = new ReactApiService();
	
  const onAddNewMask = () => {
		setSaveButtonDisabled(true);
		const masks = document.getElementById('wpglobus-to-new-mask').value;
		dataService.post({endpoint:'updateMasks',body:{masks:masks,action:'addNewMask'}})
			.then( 
				(response) => {
					setSaveButtonDisabled(false);
				}
			).then(() => {
				handleClose();
				props.afterSave();
			})
	}

  return (
    <div>
			<AddButton size="large" color="secondary" aria-label="add" onClick={handleClickOpen} >
				<AddIcon />
			</AddButton>			
      <Dialog onClose={handleClose} aria-labelledby="wpglobus-to-dialog-title" open={open}>
        <DialogTitle id="wpglobus-to-dialog-title" onClose={handleClose}>
          Add new mask
        </DialogTitle>
        <DialogContent dividers>
					<TextField
							type={'text'}
							name={'wpglobus-to-new-mask'}
							defaultValue={''}
							size='medium'
							fullWidth
							InputProps={{id:'wpglobus-to-new-mask'}}
							onChange={onChange}
					/> 						
        </DialogContent>
        <DialogActions>
          <SaveButton variant="extended" onClick={onAddNewMask} color="primary" disabled={saveButtonDisabled} >
            Save
          </SaveButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
